import { render, staticRenderFns } from "./InsuranceDictionaryMngtDtl.vue?vue&type=template&id=03fa1284"
import script from "./InsuranceDictionaryMngtDtl.vue?vue&type=script&lang=js"
export * from "./InsuranceDictionaryMngtDtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports